import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ZoomTable from '../../commons/zoomTable/zoomTable';
import Select from '../../commons/formElements/select/select';

import styles from './manageVehicles.scss';
import AddNewVehicleModal from './addNewVehicleModal';
import {
  addNewVehicle,
  deleteVehicle,
  editVehicle,
  fetchAllVehicles,
  getVehicleTypes,
  getVendorNames,
  toggleModalState,
  updateFilterFields,
  updatePageNumber,
  updateVehicleData,
  uploadImage,
  uploadVehicleImages,
  deleteVehicleImage,
  deleteImageFile,
  updateVehicleAvailability
} from './manageVehiclesRedux/manageVehiclesActionCreator';
import { setPageName } from '../../../services/pageService/pageActionCreator';
import DeleteVehicleConfirmationModal from './deleteConfirmationModal';
import UpdateVehicleAvailabilityModal from './updateVehicleAvailabilityModal';

import {
  legTypeList,
  partnerTypeList,
  vehicleStatusList
} from './manageVehiclesHelper';

const pageObj = {
  pageName: 'MANAGE VEHICLES',
  betaPage: false
};

class ManageVehicles extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      legTypeList,
      partnerTypeList,
      vehicleStatusList,
      selectedLegType: null,
      selectedPartnerType: null,
      selectedVehicleStatus: null,
      isDeleteModalOpen: false,
      isUpdateVehicleAvailabilityModalOpen: false,
      vehicleData: {}
    };

    this.componentKey = 'MANAGE_VEHICLES_DASHBOARD';
    this.tableActionFunctions = {
      editVehicle: vehicleData => {
        this.editVehicle(vehicleData);
      },
      deleteVehicle: vehicleData => {
        this.deleteVehicle(vehicleData);
      },
      updateVehicleAvailability: vehicleData => {
        this.updateVehicleAvailability(vehicleData);
      }
    };
    this.legTypeNameValStrings = { nameKey: 'label', valKey: 'value' };
    this.partnerTypeNameValStrings = { nameKey: 'label', valKey: 'value' };
  }

  componentDidMount() {
    this.props.setPageName(pageObj);
    this.props.getVendorNames();
    this.props.getVehicleTypes();
  }

  componentWillReceiveProps(nextProps) {
    const filtersOld = this.props.manageVehiclesState.filters;
    const filtersNew = nextProps.manageVehiclesState.filters;

    if (
      filtersNew.legType !== filtersOld.legType ||
      (filtersNew.partnerType !== filtersOld.partnerType &&
        filtersNew.partnerType === 'RIVIGO') ||
      (filtersNew.vendorId && filtersNew.vendorId !== filtersOld.vendorId) ||
      filtersNew.vehicleStatus !== filtersOld.vehicleStatus
    ) {
      this.props.fetchAllVehicles();
    }
  }

  editVehicle = vehicleData => {
    if (vehicleData && vehicleData.id) {
      this.props.editVehicleData(vehicleData);
    }
  };

  deleteVehicle = vehicleData => {
    if (vehicleData && vehicleData.id) {
      // this.props.deleteVehicle(vehicleData.id);
      this.setState({
        isDeleteModalOpen: true,
        deleteVehicleId: vehicleData.id
      });
    }
  };

  /**
   * updateVehicleAvailability: To update vehicle availability details in state
   *
   * @param vehicleData
   */
  updateVehicleAvailability = vehicleData => {
    if (vehicleData) {
      this.setState({
        isUpdateVehicleAvailabilityModalOpen: true,
        vehicleData
      });
    }
  };

  onAddNewVehicleClicked = () => {
    this.props.toggleModalState(true);
  };

  closeAddNewVehicleModal = () => {
    this.props.toggleModalState(false);
  };

  closeDeleteConfirmationModal = () => {
    this.setState({
      deleteVehicleId: null,
      isDeleteModalOpen: false
    });
  };

  closeVehicleAvailabilityModal = () => {
    this.setState({
      isUpdateVehicleAvailabilityModalOpen: false,
      vehicleData: {}
    });
  };

  getVehicleList = list => {
    const { vehicleTypesOptions } = this.props.manageVehiclesState;
    return list.map(item => {
      let vehicleTypeObj = (vehicleTypesOptions || []).find(
        vehicleType => vehicleType.id === item.vehicleTypeId
      );
      if (vehicleTypeObj) {
        return {
          ...item,
          size: vehicleTypeObj.length,
          capacity: vehicleTypeObj.maxWeight,
          vehicleType: vehicleTypeObj.type
        };
      } else return item;
    });
  };

  render() {
    const {
      isLoading,
      allVehiclesData,
      uploadedFiles,
      vehicleS3Urls,
      vehicleTypesOptions,
      filters,
      newVehicleAdded,
      toEditVehicle
    } = this.props.manageVehiclesState;
    return (
      <div className={styles.manageVehiclesDashboard}>
        <div className={styles.filterWrapper}>
          <div className={styles.filters}>
            <div className={styles.filterElem}>
              <Select
                label="Leg Type"
                optionsArrOfObj={this.state.legTypeList}
                selectedOpt={this.state.selectedLegType}
                nameValStrings={this.legTypeNameValStrings}
                onSelect={(val, obj) => {
                  this.props.updateFilterFields('legType', val);
                }}
                disabled={false}
                enableSearch={false}
                disableNone={true}
              />
            </div>
            <div className={styles.filterElem}>
              <Select
                label="Partner Type"
                optionsArrOfObj={this.state.partnerTypeList}
                selectedOpt={this.state.selectedPartnerType}
                nameValStrings={this.partnerTypeNameValStrings}
                onSelect={(val, obj) => {
                  this.props.updateFilterFields('partnerType', val);
                  if (val === 'RIVIGO') {
                    this.props.updateFilterFields('vendorId', 59);
                  } else {
                    this.props.updateFilterFields('vendorId', null);
                  }
                  this.props.updateFilterFields('vendorName', null);
                }}
                disabled={false}
                enableSearch={false}
                disableNone={true}
              />
            </div>
            {filters.partnerType !== 'RIVIGO' && (
              <div className={styles.filterElem}>
                <Select
                  label="Vendor Name"
                  optionsArrOfObj={
                    this.props.manageVehiclesState.allVendorNames || []
                  }
                  selectedOpt={this.state.selectedVendorName}
                  nameValStrings={this.partnerTypeNameValStrings}
                  onSelect={(val, obj) => {
                    this.props.updateFilterFields(
                      'vendorId',
                      (obj || {}).value
                    );
                    this.props.updateFilterFields('vendorName', val);
                  }}
                  disabled={
                    filters.partnerType && filters.partnerType === 'RIVIGO'
                  }
                  enableSearch={true}
                  disableNone={true}
                />
              </div>
            )}
            <div className={styles.filterElem}>
              <Select
                label="Vehicle Status"
                optionsArrOfObj={this.state.vehicleStatusList || []}
                selectedOpt={this.state.selectedVehicleStatus}
                nameValStrings={this.partnerTypeNameValStrings}
                onSelect={(val, obj) => {
                  this.props.updateFilterFields('vehicleStatus', obj.value);
                }}
                disabled={false}
                disableNone={true}
              />
            </div>
            <button
              disabled={
                (filters.partnerType === 'VENDOR' && !filters.vendorId) ||
                !filters.partnerType ||
                !filters.legType
              }
              className={styles.submitButton}
              onClick={this.onAddNewVehicleClicked}
            >
              Add new vehicle
            </button>
          </div>
        </div>
        {allVehiclesData && allVehiclesData.vehicleList && (
          <ZoomTable
            loading={isLoading}
            configKey={this.componentKey}
            tableData={this.getVehicleList(allVehiclesData.vehicleList)}
            tableDataLength={allVehiclesData.vehicleList.length}
            actionFunctions={this.tableActionFunctions}
            paginationProps={{
              showPagination: true,
              page: allVehiclesData.pageNumber,
              pageSize: allVehiclesData.vehicleList.length,
              serverSidePagination: true,
              pages: Math.ceil(
                allVehiclesData.totalElements / allVehiclesData.pageSize
              ),
              onFetchData: tableState => {
                this.props.updatePageNumber(tableState.page);
                this.props.fetchAllVehicles();
              }
            }}
          />
        )}
        <AddNewVehicleModal
          isLoading={isLoading}
          showModal={this.props.manageVehiclesState.isModalOpen}
          title={toEditVehicle ? 'Edit Vehicle' : 'Add New Vehicle'}
          closeModal={this.closeAddNewVehicleModal}
          uploadImage={this.props.uploadImage}
          uploadVehicleImages={this.props.uploadVehicleImages}
          uploadedFiles={uploadedFiles}
          vehicleS3Urls={vehicleS3Urls}
          filters={this.props.manageVehiclesState.filters}
          addNewVehicle={this.props.addNewVehicle}
          updateVehicleData={this.props.updateVehicleData}
          vehicleTypesOptions={vehicleTypesOptions}
          toEditVehicle={toEditVehicle}
          newVehicleAdded={this.props.manageVehiclesState.newVehicleAdded}
          deleteVehicleImage={this.props.deleteVehicleImage}
          deleteImageFile={this.props.deleteImageFile}
          isOutsideRangeCheck={true}
        />

        <DeleteVehicleConfirmationModal
          vehicleId={this.state.deleteVehicleId}
          showModal={this.state.isDeleteModalOpen}
          title="Delete Vehicle"
          closeModal={this.closeDeleteConfirmationModal}
          deleteVehicle={() => {
            this.props.deleteVehicle(this.state.deleteVehicleId);
            this.closeDeleteConfirmationModal();
          }}
        />

        <UpdateVehicleAvailabilityModal
          title="Update Availability"
          showModal={this.state.isUpdateVehicleAvailabilityModalOpen}
          closeModal={this.closeVehicleAvailabilityModal}
          vehicleData={this.state.vehicleData}
          updateVehicleAvailability={this.props.updateVehicleAvailability}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  manageVehiclesState: state.manageVehiclesState
});

const mapDispatchToProps = dispatch => ({
  setPageName: bindActionCreators(setPageName, dispatch),
  getVendorNames: bindActionCreators(getVendorNames, dispatch),
  fetchAllVehicles: bindActionCreators(fetchAllVehicles, dispatch),
  updatePageNumber: bindActionCreators(updatePageNumber, dispatch),
  uploadImage: bindActionCreators(uploadImage, dispatch),
  uploadVehicleImages: bindActionCreators(uploadVehicleImages, dispatch),
  addNewVehicle: bindActionCreators(addNewVehicle, dispatch),
  deleteVehicle: bindActionCreators(deleteVehicle, dispatch),
  getVehicleTypes: bindActionCreators(getVehicleTypes, dispatch),
  updateFilterFields: bindActionCreators(updateFilterFields, dispatch),
  toggleModalState: bindActionCreators(toggleModalState, dispatch),
  editVehicleData: bindActionCreators(editVehicle, dispatch),
  updateVehicleData: bindActionCreators(updateVehicleData, dispatch),
  deleteVehicleImage: bindActionCreators(deleteVehicleImage, dispatch),
  updateVehicleAvailability: bindActionCreators(
    updateVehicleAvailability,
    dispatch
  ),
  deleteImageFile: bindActionCreators(deleteImageFile, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageVehicles);
